import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × YVES SAINT LAURENT: Parisian geometry
// Vertical alignment, gold monogram, shadow symmetry
export function VasarelyYslMode({ brand }: ModeRendererProps) {
  const yslGold = "#D4AF37";
  const yslBlack = "#000000";

  return (
    <g>
      {/* Elegant black background */}
      <rect x="0" y="0" width="794" height="1123" fill={yslBlack} />

      <g transform="translate(397 540)">
        {/* Vertical alignment lines (Parisian poise) */}
        {Array.from({ length: 16 }).map((_, i) => {
          const x = -280 + i * 35;
          return (
            <line
              key={i}
              x1={x}
              y1="-300"
              x2={x}
              y2="300"
              stroke={yslGold}
              strokeWidth={i % 2 === 0 ? 2 : 1}
              opacity={i % 2 === 0 ? 0.4 : 0.2}
            />
          );
        })}

        {/* YSL monogram inspiration (interlocking) */}
        {[-1, 1].map((dir) => (
          <g key={dir}>
            <ellipse
              cx={dir * 50}
              cy="-30"
              rx="40"
              ry="70"
              fill="none"
              stroke={yslGold}
              strokeWidth="4"
              opacity="0.6"
            />
            <ellipse
              cx={dir * 50}
              cy="30"
              rx="40"
              ry="70"
              fill="none"
              stroke={yslGold}
              strokeWidth="4"
              opacity="0.6"
            />
          </g>
        ))}

        {/* Shadow symmetry layers */}
        {Array.from({ length: 10 }).map((_, i) => {
          const offset = i * 8;
          return (
            <rect
              key={i}
              x={-120 + offset}
              y={-100 + offset}
              width="240 - offset * 2"
              height="200 - offset * 2"
              fill="none"
              stroke={yslGold}
              strokeWidth="1"
              opacity={0.2 - i * 0.015}
            />
          );
        })}

        {/* Gold accent circles */}
        {Array.from({ length: 14 }).map((_, i) => {
          const r = 50 + i * 18;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={yslGold}
              strokeWidth="1"
              opacity={0.3 - i * 0.015}
            />
          );
        })}

        {/* Geometric poise nodes */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 210;
          
          return (
            <g key={angle}>
              <rect
                x={Math.cos(rad) * r - 10}
                y={Math.sin(rad) * r - 15}
                width="20"
                height="30"
                fill={yslGold}
                opacity="0.5"
              />
              <rect
                x={Math.cos(rad) * r - 10}
                y={Math.sin(rad) * r - 15}
                width="20"
                height="30"
                fill="none"
                stroke={yslGold}
                strokeWidth="2"
                opacity="0.7"
              />
            </g>
          );
        })}

        {/* Central medallion */}
        <rect x="-70" y="-90" width="140" height="180" fill={yslGold} opacity="0.2" />
        <rect x="-70" y="-90" width="140" height="180" fill="none" stroke={yslGold} strokeWidth="3" opacity="0.7" />
        
        {/* YSL initials suggestion (abstract) */}
        <line x1="-40" y1="-60" x2="-40" y2="60" stroke={yslBlack} strokeWidth="4" opacity="0.7" />
        <line x1="0" y1="-60" x2="0" y2="60" stroke={yslBlack} strokeWidth="4" opacity="0.7" />
        <circle cx="0" cy="0" r="35" fill="none" stroke={yslBlack} strokeWidth="4" opacity="0.7" />
        <line x1="40" y1="-60" x2="40" y2="60" stroke={yslBlack} strokeWidth="4" opacity="0.7" />
      </g>

      {/* YSL text */}
      <text x="397" y="1030" textAnchor="middle" fontFamily="serif" fontSize="11" fill={yslGold} opacity="0.8" fontStyle="italic">
        géométrie parisienne
      </text>
    </g>
  );
}
